//libraries imports
import {
  BrowserRouter,
  Link,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";

// page reference imports
// import { WatizenLogin } from "./components/SlidingOverlay/WatizenLogin";
import { VerifyOtp } from "./components/SlidingOverlay/WatizenVerify";
// import { WatizenRegistration } from "./components/SlidingOverlay/WatizenRegistration";
// import { AddEditSubCategories } from "components/StorePanel/AddEditSubCategories";
import { WatizenSuccessful } from "./components/SlidingOverlay/WatizenSuccessful";
import { WatizenDashboard } from "./components/SlidingOverlay/WatizenDashboard";
// import { AddEditCatalogue } from "components/StorePanel/AddEditCatalogue";
import { SlidingOverlay } from "components/SlidingOverlay/SlidingOverlay";
import { FeaturedListings } from "components/StorePanel/FeaturedListings";
import { StoreProducts } from "./components/StoreProducts/StoreProducts";
import { Notifications } from "components/SlidingOverlay/Notifications";
import { WatizenCode } from "./components/SlidingOverlay/WatizenCode";
import { WatizenPanel } from "components/SlidingOverlay/WatizenPanel";
import { WatizenList } from "./components/SlidingOverlay/WatizenList";
import { StorePanelList } from "components/StorePanel/StorePanelList";
import { StoreDashboard } from "components/StorePanel/StoreDashboard";
import { AppSettings } from "components/SlidingOverlay/AppSettings";
import { UserProfile } from "components/SlidingOverlay/UserProfile";
import { ManageOrders } from "./components/StorePanel/ManageOrders";
import { LanguageSetting } from "./pages/AuthPage/LanguageSetting";
import { StorePanel } from "components/SlidingOverlay/StorePanel";
//import { PIActivity } from "components/SlidingOverlay/PIActivity";
import { ManageOffers } from "components/StorePanel/ManageOffers";
import { PostItemPage } from "./pages/PostItemPage/PostItemPage";
import { CategoriesPage } from "./pages/CategoriesPage/CategoriesPage";
import { Messages } from "components/SlidingOverlay/Messages";
import { Feedback } from "components/SlidingOverlay/Feedback";
import { StoreLogIn } from "components/StorePanel/StoreLogIn";
import { ProductPage } from "pages/ProductPage/ProductPage";
import { MyItems } from "components/SlidingOverlay/MyItems";
import { StoresPage } from "./pages/StoresPage/StoresPage";
import { ItemsPage } from "./pages/ItemsPage/ItemsPage";
import { FAQ } from "components/SlidingOverlay/FAQ";
import { Location } from "components/SlidingOverlay/locations";
import { HomePage } from "pages/HomePage/HomePage";
import { Navbar } from "components/Navbar/Navbar";
import { LogIn } from "./pages/AuthPage/LogIn";
import { PhoneNumber } from "./pages/AuthPage/PhoneNumber";
import { Verification } from "./pages/AuthPage/Verification";
import { VerifyAccount } from "./pages/AuthPage/VerifyAccount";
import { VerifyOTP } from "./pages/AuthPage/VerifyOTP";
import { AddAddress } from "./pages/AuthPage/AddAddress";
import { WishlistPage } from "./pages/WishlistPage/WishlistPage";
import { Register } from "./pages/AuthPage/Register";
import { Transactionsuccess } from "./pages/transaction/ts";

// styles imports
import "antd/dist/antd.min.css";
import "./antdOverwtites.scss";
import "./App.css";
import { useEffect, useMemo, useState } from "react";
import { store } from "./store/index.store";
import { PresentationPage } from "./pages/PresentationPage";
import { CategoryPage } from "./pages/CategoryPage/CategoryPage";
import { observer } from "mobx-react-lite";
import { EditItemsPage } from "./pages/EditItemsPage/EditItemsPage";
import { SearchPage } from "./pages/SearchPage/SearchPage";
import { ResetPassword } from "./pages/ResetPassword/ResetPassword";
import { ItemsActivityPage } from "./pages/ItemsActivityPage/ItemsActivityPage";
import Modal from "antd/lib/modal/Modal";
import { Rate } from "antd";
import { reviewTransaction } from "./api/transactions";
import { UsersProductPage } from "./pages/UsersProductPage/UsersProductPage";
import { ChatPage } from "./pages/ChatPage/ChatPage";
import { io } from "socket.io-client";

const App = observer(() => {
  const { authStore, UIStore } = store;
  const { checkIfLoggedIn, loadWishes } = authStore;

  const [txRatings, setTxRatings] = useState<{ [key: string]: number }>({});

  const [locationModal, setLocationModal] = useState(false);

  const [showVersionModal, setShowVersionModal] = useState<boolean | null>(
    null
  );

  useEffect(() => {
    //connect the status websocket

    io(process.env.REACT_APP_API_URL!, {
      path: "/online",
      auth: {
        token: localStorage.getItem("token"),
      },

      transports: ["websocket"],
    });
  }, []);

  useEffect(() => {
    if (
      authStore.isLoggedIn &&
      !authStore.userProfile.location &&
      authStore.userProfile.email
    ) {
      setLocationModal(true);
    }
  }, [authStore.userProfile.location, authStore.isLoggedIn]);

  useEffect(() => {
    checkIfLoggedIn()
      .then((res) => {
        if (res) {
          loadWishes();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    authStore.userProfile.unreviewedTransactions?.forEach((transaction) => {
      authStore.loadTxData(transaction);
    });
  }, [authStore.userProfile.unreviewedTransactions]);

  const Protected = observer(({ element: Component }: any) => {
    const navigate = useNavigate();
    const { authStore } = store;
    const { isLoggedIn } = authStore;

    if (!isLoggedIn) {
      navigate("/login");
      return <HomePage />;
    }

    return <Component />;
  });

  const PathAnalytics = () => {
    const location = useLocation();

    useEffect(() => {
      window.dataLayer.push(
        {
          event: "pageview",
          page: location.pathname,
        },
        "pageview"
      );
    }, [location]);

    return <></>;
  };

  const isVersionQuerryParam = useMemo(() => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("version");
  }, [window.location.search]);

  useEffect(() => {
    if (
      (isVersionQuerryParam && showVersionModal === null) ||
      showVersionModal
    ) {
      setShowVersionModal(true);
    } else {
      setShowVersionModal(false);
    }
  }, [isVersionQuerryParam, showVersionModal]);

  const shouldReviewTxs = useMemo(() => {
    return authStore.userProfile.unreviewedTransactions?.filter((el) => {
      return !authStore.canceledTxReviews.includes(el);
    });
  }, [
    authStore.userProfile.unreviewedTransactions,
    authStore.canceledTxReviews,
  ]);

  return (
    <div className="App">
      {shouldReviewTxs?.map((txId) => (
        <Modal
          open={true}
          title="Review your transaction"
          key={txId}
          onCancel={() => {
            authStore.cancelTxReview(txId);
          }}
          onOk={() => {
            reviewTransaction(txId, txRatings[txId]);
            authStore.cancelTxReview(txId);
          }}
        >
          <div>
            <p>
              Please review your transaction you made for:{" "}
              <b>{authStore.transactionsData?.[txId]?.productName}</b> on{" "}
              <b>
                {new Date(
                  authStore.transactionsData?.[txId]?.createdAt
                ).toDateString()}
              </b>{" "}
              ammounting to <b>{authStore.transactionsData?.[txId]?.amount}</b>{" "}
              PI
            </p>
            <Rate
              defaultValue={3}
              value={txRatings[txId]}
              onChange={(value) => {
                setTxRatings({ ...txRatings, [txId]: value });
              }}
            />
          </div>
        </Modal>
      ))}
      <Modal
        open={UIStore.paymentStartedModal}
        title="Payment Started"
        onCancel={() => {
          UIStore.setPaymentStartedModal(false);
        }}
        onOk={() => {
          UIStore.setPaymentStartedModal(false);
        }}
      >
        Your payment has started. You can check the completion status by
        visiting the PI Activity page. For the seller to recive the payment it
        will take a bit, please be patient.
      </Modal>

      <Modal
        open={!!showVersionModal}
        title="Version"
        onCancel={() => {
          setShowVersionModal(false);
        }}
        onOk={() => {
          setShowVersionModal(false);
        }}
      >
        <p>Current version date: {process.env.REACT_APP_BUILD_DATE}</p>
      </Modal>

      <BrowserRouter>
        <Modal
          open={locationModal}
          title="Location service unavable"
          onCancel={() => {
            setLocationModal(false);
          }}
          onOk={() => {
            setLocationModal(false);
          }}
        >
          <p>
            Please set your location to be able to use the app. You can do this
            in the settings
          </p>
          <Link to="/settings/location" onClick={() => setLocationModal(false)}>
            Click here
          </Link>{" "}
          to set your location
        </Modal>
        <PathAnalytics />
        <Navbar />
        <SlidingOverlay />
        <Routes>
          <Route path="/home-page" index element={<HomePage />} />
          <Route path="/" element={<PresentationPage />} />

          <Route path="/login" element={<LogIn />} />
          <Route path="/login-register" element={<Register />} />
          {/* <Route
            path="/addEditSubCategories"
            element={<AddEditSubCategories />}
          /> */}

          {/* <Route path="/addEditCatalogue" element={<AddEditCatalogue />} /> */}
          <Route
            path="/addAddress"
            element={<Protected element={AddAddress} />}
          />
          <Route
            path="/storeProducts"
            element={<Protected element={StoreProducts} />}
          />
          <Route
            path="/storeLogin"
            element={<Protected element={StoreLogIn} />}
          />
          <Route
            path="/storePanelList"
            element={<Protected element={StorePanelList} />}
          />
          <Route path="/categories" element={<CategoriesPage />} />
          <Route path="/category/:id" element={<CategoryPage />} />
          <Route
            path="/dashboard"
            element={<Protected element={StoreDashboard} />}
          />
          <Route
            path="/featuredListing"
            element={<Protected element={FeaturedListings} />}
          />
          <Route path="/product/:id" element={<ProductPage />} />
          <Route path="/myItems" element={<Protected element={MyItems} />} />
          <Route
            path="/userProfile"
            element={<Protected element={UserProfile} />}
          />
          <Route
            path="/manageOffers"
            element={<Protected element={ManageOffers} />}
          />
          <Route
            path="/manageOrders"
            element={<Protected element={ManageOrders} />}
          />
          <Route
            path="/notifications"
            element={<Protected element={Notifications} />}
          />
          <Route path="/messages" element={<Protected element={Messages} />} />
          <Route
            path="/watizenCode"
            element={<Protected element={WatizenCode} />}
          />
          <Route
            path="/watizenDashboard"
            element={<Protected element={WatizenDashboard} />}
          />
          <Route
            path="/watizenPanel"
            element={<Protected element={WatizenPanel} />}
          />
          <Route
            path="/watizenList"
            element={<Protected element={WatizenList} />}
          />
          <Route
            path="/watizenSuccessful"
            element={<Protected element={WatizenSuccessful} />}
          />

          <Route path="/verify" element={<VerifyOtp />} />
          <Route path="/stores" element={<StoresPage />} />
          <Route
            path="/storePanel"
            element={<Protected element={StorePanel} />}
          />
          <Route path="/verifyAccount" element={<VerifyAccount />} />
          <Route path="/phoneVerification" element={<PhoneNumber />} />
          <Route path="/verification" element={<Verification />} />
          <Route path="/verifyOTP" element={<VerifyOTP />} />
          <Route path="/location" element={<Protected element={Location} />} />
          <Route path="/languageSetting" element={<LanguageSetting />} />
          <Route
            path="/piActivity"
            element={<Protected element={ItemsActivityPage} />}
          />
          <Route
            path="/settings"
            element={<Protected element={AppSettings} />}
          />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/feedback" element={<Protected element={Feedback} />} />
          <Route path="/items" element={<ItemsPage />} />
          <Route
            path="/post-product"
            element={<Protected element={PostItemPage} />}
          />
          <Route
            path="/edit-product/:id"
            element={<Protected element={PostItemPage} />}
          />
          <Route
            path="/myItems/wishlist"
            element={<Protected element={WishlistPage} />}
          />
          <Route
            path="/myItems/my-posted-items"
            element={<Protected element={EditItemsPage} />}
          />
          <Route
            path="/transaction-success"
            element={<Protected element={Transactionsuccess} />}
          />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          {/* <Route
            path="/myItems/items-activity"
            element={<ItemsActivityPage />}
          /> */}
          <Route path="/user/products/:userId" element={<UsersProductPage />} />
          <Route path="/settings/location" element={<Location />} />

          <Route path="/chats/:chatId" element={<ChatPage />} />
          <Route path="/product/:id/:chatId" element={<ChatPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
});

export default App;
